import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Comment } from '../types';

interface CommentsState {
  byPhotoId: Record<number, Comment[]>;
  loading: boolean;
  error: string | null;
}

const initialState: CommentsState = {
  byPhotoId: {},
  loading: false,
  error: null,
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    setCommentsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCommentsByPhoto: (state, action: PayloadAction<{ photoId: number; comments: Comment[] }>) => {
      state.byPhotoId[action.payload.photoId] = action.payload.comments;
    },
    addComment: (state, action: PayloadAction<Comment>) => {
      const comment = action.payload;
      if (!state.byPhotoId[comment.photo_id]) {
        state.byPhotoId[comment.photo_id] = [];
      }
      state.byPhotoId[comment.photo_id].unshift(comment);
    },
    updateComment: (state, action: PayloadAction<Comment>) => {
      const comment = action.payload;
      if (state.byPhotoId[comment.photo_id]) {
        const index = state.byPhotoId[comment.photo_id].findIndex((c) => c.id === comment.id);
        if (index !== -1) {
          state.byPhotoId[comment.photo_id][index] = comment;
        }
      }
    },
    deleteComment: (state, action: PayloadAction<{ photoId: number; commentId: number }>) => {
      const { photoId, commentId } = action.payload;
      if (state.byPhotoId[photoId]) {
        state.byPhotoId[photoId] = state.byPhotoId[photoId].filter((c) => c.id !== commentId);
      }
    },
    clearComments: (state) => {
      state.byPhotoId = {};
    },
  },
});

export const {
  setCommentsLoading,
  setCommentsByPhoto,
  addComment,
  updateComment,
  deleteComment,
  clearComments,
} = commentsSlice.actions;

export default commentsSlice.reducer;
